import axios from '@/api/provider';

const saveLabelMapping = async (mapping) => {
  return axios
    .post('label-mappings', {
      mapping: mapping
    })
    .then((response) => ({
      success: true,
      data: response
    }))
    .catch((error) => {
      console.error('Save label mapping error:', error);
      throw error;
    });
};

const getLabelMappings = async () => {
  return axios
    .get('label-mappings')
    .then((response) => ({
      success: true,
      mappings: response
    }))
    .catch((error) => {
      console.error('Get label mappings error:', error);
      throw error;
    });
};


export default {
  saveLabelMapping,
  getLabelMappings
};
